export default __webpack_public_path__ + "static/media/cheetos-image.e78420d9.png";